const wishlistSection = document.querySelector('.sc-wishlist');
if (wishlistSection) {
  initComparison();
}
